import type { RouteLocationRaw } from 'vue-router';

import i18n from '@/i18n';

import type {
	FollowingBaseInput,
	FollowingLineGeneratorResult,
} from '@/components/following/types';

import {
	createLinkSegment,
	createReadonlyLabelSegment,
	createTextSegment,
} from './segmentFactory';

export interface JobApplicationFollowingInput extends FollowingBaseInput {
	announceName: string;
	announceTo?: RouteLocationRaw;
	besoinName: string;
	besoinTo?: RouteLocationRaw;
}

const t = (key: string): string => i18n.global.t(key);

/**
 * Builds FollowingLine props for a candidature event.
 * Renders: "Nouvelle candidature à [annonce] dans [besoin]"
 */
export const buildFollowingLineCandidatures = (
	input: JobApplicationFollowingInput
): FollowingLineGeneratorResult => {
	return {
		icon: 'users',
		segments: [
			createTextSegment(t('following.labels.candidatures.label')),
			input.announceTo
				? createLinkSegment(input.announceName, {
						leftIcon: 'megaphone-fill',
						to: input.announceTo,
						iconColor: 'var(--icon-sub-500, #636778)',
					})
				: createReadonlyLabelSegment(input.announceName, {
						leftIcon: 'megaphone-fill',
						iconColor: 'var(--icon-sub-500, #636778)',
					}),
			createTextSegment(t('following.labels.candidatures.inBesoin')),
			input.besoinTo
				? createLinkSegment(input.besoinName, { to: input.besoinTo })
				: createReadonlyLabelSegment(input.besoinName),
		],
		detail: input.detail,
	};
};
